import React from "react"
import { PencilSquareIcon } from "@heroicons/react/24/outline"
import useDashboardTexts from "../useDashboardTexts"

/** A card's frame: its title, the edit button, and what it shows. */
export default function CardFrame({ title, subtitle, onEdit, children, className = "", testId }) {
  const t = useDashboardTexts()
  return (
    // as tall as the tallest card of its row (the grid stretches its cells)
    <div className={`group flex flex-col h-full rounded-xl border border-admin_bordered bg-admin_paper p-4 min-w-0 ${className}`} data-testid={testId}>
      <div className="flex items-start gap-2 mb-2">
        <div className="flex-1 min-w-0">
          <div className="text-xs font-semibold uppercase tracking-wide text-admin_text_secondary truncate">{title}</div>
          {subtitle && <div className="text-[11px] text-admin_text_secondary truncate">{subtitle}</div>}
        </div>
        {onEdit && (
          <button type="button" onClick={onEdit} className="shrink-0 p-1 rounded text-admin_text_secondary opacity-0 group-hover:opacity-100 focus:opacity-100 hover:text-admin_primary hover:bg-admin_neutral_1" title={t`Edit card`}>
            <PencilSquareIcon className="w-4 h-4" />
          </button>
        )}
      </div>
      {children}
    </div>
  )
}
